<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
  <mat-select [(value)]="value" [compareWith]="compareWith" [disabled]="disabled" [formControl]="ChildControl"
              [multiple]="multiple" [required]="required" name="Country">
    <mat-option *ngFor="let opt of Countries" [value]="getOnlyId ? opt.Id : opt">{{opt.Name}}</mat-option>
  </mat-select>
  <span [ngTemplateOutlet]="matSuffix" matSuffix></span>
</mat-form-field>
